import moment, { Moment } from 'moment-timezone';

export const createTaskDate = (date: Moment, timeString: string, timezone: string): Moment => {
    const formattedTimeString = timeString.replace(':', '');
    const paddedTimeString = formattedTimeString.padStart(4, '0');
    const hour = parseInt(paddedTimeString.substring(0, 2), 10);
    const minute = parseInt(paddedTimeString.substring(2, 4), 10);

    const selectedHour = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} ${
        hour >= 12 ? 'PM' : 'AM'
    }`;

    const baseDate = date.clone().tz(timezone);

    return moment.tz(`${baseDate.format('YYYY-MM-DD')} ${selectedHour.toUpperCase()}`, 'YYYY-MM-DD hh:mm A', timezone);
};

export const createMedicationTaskDate = (date: Moment, scheduleTime: string, timezone: string): Moment => {
    const normalizedTime = (scheduleTime || '').trim().toUpperCase();

    const parsed = moment(normalizedTime, ['h:mm A', 'hh:mm A', 'h:mmA', 'hh:mmA', 'H:mm', 'HH:mm'], true);

    const baseDate = date.clone().tz(timezone);

    const hour = parsed.isValid() ? parsed.hour() : 9;
    const minute = parsed.isValid() ? parsed.minute() : 0;

    const selectedHour = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} ${
        hour >= 12 ? 'PM' : 'AM'
    }`;

    return moment.tz(`${baseDate.format('YYYY-MM-DD')} ${selectedHour.toUpperCase()}`, 'YYYY-MM-DD hh:mm A', timezone);
};

export const getRangeDateByMomentTypeIdWithTimezone = (
    date: Moment,
    momentTypeId: number,
    morningTime: string,
    afternoonTime: string,
    eveningTime: string,
    timezone: string
) => {
    let timeStart = '';
    let timeEnd = '';

    if (momentTypeId === 1) {
        timeStart = morningTime;
        timeEnd = afternoonTime;
    } else if (momentTypeId === 2) {
        timeStart = afternoonTime;
        timeEnd = eveningTime;
    } else {
        timeStart = eveningTime;
        timeEnd = '2359';
    }

    const formattedTimeStartString = timeStart.replace(':', '');
    const formattedTimeEndString = timeEnd.replace(':', '');
    const paddedTimeStart = formattedTimeStartString.padStart(4, '0');
    const paddedTimeEnd = formattedTimeEndString.padStart(4, '0');

    const hourStart = parseInt(paddedTimeStart.substring(0, 2), 10);
    const minuteStart = parseInt(paddedTimeStart.substring(2, 4), 10);

    const hourEnd = parseInt(paddedTimeEnd.substring(0, 2), 10);
    const minuteEnd = parseInt(paddedTimeEnd.substring(2, 4), 10);

    const selectedHourStart = `${hourStart.toString().padStart(2, '0')}:${minuteStart.toString().padStart(2, '0')} ${
        hourStart >= 12 ? 'PM' : 'AM'
    }`;

    const selectedHourEnd = `${hourEnd.toString().padStart(2, '0')}:${minuteEnd.toString().padStart(2, '0')} ${
        hourEnd >= 12 ? 'PM' : 'AM'
    }`;

    const baseDate = date.clone().tz(timezone);

    return {
        from: moment.tz(
            `${baseDate.format('YYYY-MM-DD')} ${selectedHourStart.toUpperCase()}`,
            'YYYY-MM-DD hh:mm A',
            timezone
        ),
        to: moment.tz(
            `${baseDate.format('YYYY-MM-DD')} ${selectedHourEnd.toUpperCase()}`,
            'YYYY-MM-DD hh:mm A',
            timezone
        )
    };
};

export const shouldCreateTaskForDay = (
    taskDate: Moment,
    startDate: Moment,
    endDate: Moment,
    rangeFrom: Moment,
    rangeTo: Moment
): boolean => {
    const hasIntersection =
        (startDate.isSameOrAfter(rangeFrom) && startDate.isBefore(rangeTo)) ||
        (endDate.isAfter(rangeFrom) && endDate.isBefore(rangeTo)) ||
        (rangeFrom.isSameOrAfter(startDate) && rangeFrom.isBefore(endDate)) ||
        (rangeTo.isAfter(startDate) && rangeTo.isBefore(endDate)) ||
        (startDate.isSameOrBefore(rangeFrom) && endDate.isAfter(rangeTo));

    return hasIntersection;
};
